import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { File, Product } from 'depoto-core/src/entities'
import { ModalContainerComponent } from '../modal-container/modal-container.component'
import * as Sentry from '@sentry/angular-ivy'
import { getThumbUrl as imageGetThumbUrl } from '../../../utils'

@Component({
  selector: 'product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.scss'],
})
export class ProductImageComponent implements OnInit {
  @ViewChild('modal') public childModal: ModalContainerComponent
  @Input() product: Product
  @Input() image: File
  thumbnailUrl: string
  imageUrl: string
  label: string
  isImageLoaded = false

  ngOnInit() {
    try {
      if (this.image && this.image.id > 0) {
        this.thumbnailUrl = imageGetThumbUrl(this.image)
        this.imageUrl = imageGetThumbUrl(this.image, 'w2048wp')
        this.label = this.image.text
      } else if (
        this.product &&
        this.product.id > 0 &&
        this.product.mainImage?.thumbnails &&
        this.product.mainImage?.thumbnails?.length
      ) {
        this.thumbnailUrl = this.product.mainImage ? imageGetThumbUrl(this.product.mainImage) : null
        this.imageUrl = this.product.mainImage ? imageGetThumbUrl(this.product.mainImage, 'w2048wp') : null
        this.label = this.product.name
      }
    } catch (e) {
      console.log(e)
    }
  }

  show(): void {
    this.isImageLoaded = true
    setTimeout(() => this.childModal.showChildModal(), 250)
  }

  hide(): void {
    this.childModal.hideChildModal()
    this.isImageLoaded = false
  }

  get restOfProductImages(): File[] {
    return this.product.images.slice(1)
  }

  protected readonly getThumbUrl = imageGetThumbUrl
}
